import {
  Button,
  Card,
  CardHeader,
  withStyles,
  WithStyles,
} from "@material-ui/core";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { AddCoupon } from "../Coupons/Dialogs";
import { AddAddressDialog } from "../Address/Dialogs";
import { AddAccount } from "../Accounts/Dialogs";
import { styles } from "./styles";

interface HomeHeaderProps extends WithStyles<typeof styles> {}

function HomeHeader({ classes }: HomeHeaderProps) {
  const history = useHistory();

  const [showAddAccountModal, setAddAccountModal] = useState(false);
  const [showAddCouponModal, setAddCouponModal] = useState(false);
  const [showAddAddressModal, setAddAddressModal] = useState(false);

  return (
    <Card square elevation={0} className={classes.mainCard}>
      <CardHeader
        action={
          <>
            <Button
              color="primary"
              variant="contained"
              className={classes.headerButton}
              onClick={() => setAddAccountModal(true)}
            >
              Add a user account
            </Button>

            <Button
              color="primary"
              variant="contained"
              className={classes.headerButton}
              onClick={() => setAddAddressModal(true)}
            >
              Add an address
            </Button>

            <Button
              color="primary"
              variant="contained"
              className={classes.headerButton}
              onClick={() => setAddCouponModal(true)}
            >
              Add a coupon
            </Button>

            <Button
              color="primary"
              variant="contained"
              className={classes.headerButton}
              onClick={() => history.push("/order")}
            >
              Create an order
            </Button>

            <AddAddressDialog
              show={showAddAddressModal}
              onClose={() => setAddAddressModal(false)}
            />

            <AddCoupon
              show={showAddCouponModal}
              onClose={() => setAddCouponModal(false)}
            />

            <AddAccount
              show={showAddAccountModal}
              onClose={() => setAddAccountModal(false)}
            />
          </>
        }
      />
    </Card>
  );
}

export default withStyles(styles)(HomeHeader);
